/**
 * parent class has application configurations
 */
export class Sitters {
    constructor(config){
        this._config = config;
    }

   
}